<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height: 54px; line-height: 54px">
        <img style="vertical-align: middle" src="@/assets/beadhouse/juxing.png" />
        <span>健康监测管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for="(item, index) in infoList" :key="index" @click="handleClick(item)">
        <a>
          <img :src="item.img" />
          <h5 style="font-size: 16px">{{ item.title }}</h5>
          <span>{{ item.text }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "Intelligent",
  data() {
    return {
      Intelligent: {
        Intelligent: "智能看护",
        title_1: "报警记录",
        title_2: "老人地图",
        title_3: "智能网关",
        title_4: "智能电话机",
        title_5: "门禁卡",
        title_6: "门禁读卡器",
        title_7: "智能床垫",
        title_8: "睡眠监测带",
        title_9: "多功能检测仪",
        title_10: "孝心手环",
        title_11: "护工手表",
        title_12: "紧急按钮",
        title_13: "红外人感",
        title_14: "报警灯",
        title_15: "门禁组",
        title_16: "外出记录",
        title_17: "门禁控制卡",
        title_18: "门禁卡权限",
        title_19: "门禁事件记录",
        title_20: "床头屏",
        title_21: "欧姆龙人感",
        title_22: "温湿度计",
        title_23: "智能摄像头",
        title_24: "智能网关wifi",
        title_25: "睡眠监测带",
        title_26: "出入消息",
        title_27: "出入记录",
        title_28: "人感组",
        text_1: "对所有设备报警信息进行记录",
        text_2: "对老人位置进行定位记录",
        text_3: "网关管理设备之间的通信情况",
        text_4: "监测房间内的老人情况",
        text_5: "门禁对每个老人的出入情况进行管理",
        text_6: "对每一个门禁卡进行管理",
        text_7: "智能床垫可以实时监测老人的在床情况",
        text_8: "睡眠监测带可以实时监测老人的在床情况",
        text_9: "检测血压、血氧、心率、心电等数据",
        text_10: "孝心手环可以对老人进行定位监测",
        text_11: "对所有的设备报警信息进行记录",
        text_12: "紧急情况时按下按钮发出警报",
        text_13: "24小时实时感应老人的活动状态",
        text_14: "紧急情况下按下发出警报",
        text_15: "对每个老人的出入进行管理",
        text_16: "对老人外出记录进行管理",
        text_17: "对使用的门禁卡进行管理",
        text_18: "对进出入的人员的权限管理",
        text_19: "记录进出养老机构的人员数据",
        text_20: "展示房间内的老人情况",
        text_21: "实时感应老人的活动状态",
        text_22: "及时反馈房内温湿度",
        text_23: "实时监控老人在房内的情况",
        text_24: "网关管理设备之间的通信情况",
        text_25: "睡眠监测带可以实时监测老人的在床情况",
        text_26: "显示进出养老机构的出入消息",
        text_27: "记录进出养老机构的出入信息",
        text_28: "记录人感组的主要信息"
      }, //引入 lang 里面的字符串资源
        infoList: [], //数据源
    };
  },
  methods: {
    //点击每个
    handleClick(item) {
      bus.$emit("homePage", {
        type: "jump",
        path: item.url,
        title: item.title
      });
    },
    /**
     * 获取菜单栏的数据列表
     */
    getPageData() {
      this.infoList = [
         {
          img: require("@/assets/beadhouse/RoomBedSetting.png"),
          title: "体征检测雷达",
          text: "对生命体征及环境状况进行监测",
          uid: 4,
          url: '/healthRadarList'
        },{
          img: require("@/assets/beadhouse/chuangdianlist.png"),
          title: "睡眠监测带",
          text: "睡眠监测带可以监测体征及睡眠数据",
          uid: 3,
          url: '/SleepMattresslist'
        }, {
          img: require("@/assets/beadhouse/followlist.png"),
          title: this.Intelligent.title_9,
          text: this.Intelligent.text_9,
          uid: 5,
          url: '/followlist'
        }, {
          img: require("@/assets/beadhouse/watchlist.png"),
          title: this.Intelligent.title_10,
          text: this.Intelligent.text_10,
          uid: 6,
          url: '/watchlist'
        }, {
          img: require("@/assets/beadhouse/xt_cwgl.png"),
          title: "4G血压计",
          text: "测量血压并上传数据的智能血压计",
          uid: 8,
          url: '/BloodPressList'
        },{
          img: require("@/assets/beadhouse/watchcarelist.png"),
          title: "体温定位手环",
          text: "定时测量身体数据及定位防走失装置",
          uid: 7,
          url: '/bracelet'
        },
        {
          img: require("@/assets/beadhouse/oldmanmap.png"),
          title: this.Intelligent.title_2,
          text: this.Intelligent.text_2,
          uid: 2,
          url: '/oldmanmap'
        }
      ];
    },
  },
  created() {
    this.getPageData();
  },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.public_bg {
  width: 100%;
  height: 95%;
  padding: 0 0 20px 0;
  background: #fefefe;

  .nurse_top {
    border: 1px #f1eff2 solid;
    background: #f9f7fa;
    position: relative;

    img {
      margin: 14px 12px;
    }

    h5 {
      display: inline-block;
      position: absolute;
      top: 12px;
      font-size: 18px;
    }
  }

  .row_link {
    width: 1259px;
    margin: 34px 35px;

    .item {
      width: 275px;
      height: 99px;
      border: #f0f0f2 1px solid;
      margin-bottom: 34px;
      margin-right: 34px;
      float: left;
      cursor: pointer;

      img {
        float: left;
        margin: 8px 23px 8px 33px;
        margin-right: 16px;
      }

      span {
        color: #666666;
      }

      h5 {
        margin-top: 21px;
        margin-bottom: 8px;
      }

      a:hover {
        color: #333;
      }
    }

    .item:hover {
      border: 1px solid red;
    }
  }
}
</style>
